var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v("SR Details ")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('label', {
    staticClass: "mt-2"
  }, [_vm._v(" Search :   ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: "search",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Search by SR name ",
      "autocomplete": "off",
      "id": "search",
      "name": "search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])], 1)], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "SRListing",
    class: {
      row: true,
      tableFixHead1: true
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables SetTripConfig",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredSRList), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(data.DeliverySRName) + " " + _vm._s(data.DeliverySRIds))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.modifieddatetime))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "word-break": "break-all"
      }
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm.isTripAllowedForSR) + "\n              "), _c('label', {
      staticClass: "switch"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.IscheckedSRList),
        expression: "IscheckedSRList"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": _vm.isSRTripLoader == true,
        "id": data.userid
      },
      domProps: {
        "checked": data.isTripAllowedForSR,
        "value": data.userid,
        "checked": Array.isArray(_vm.IscheckedSRList) ? _vm._i(_vm.IscheckedSRList, data.userid) > -1 : (_vm.IscheckedSRList)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.IscheckedSRList,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data.userid,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.IscheckedSRList = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.IscheckedSRList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.IscheckedSRList = $$c
          }
        }, function($event) {
          return _vm.SetSRTripConfiguration($event, data.userid, data.isTripAllowedForSR, data.OldDeliveryUserOrUserId)
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "slider round"
    })])])])
  }), _vm._v(" "), (_vm.filteredSRList == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "9",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]), _c('br')])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr No.")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Sr Name ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Date & Time ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v(" Modified By ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "z-index": "22"
    }
  }, [_c('b', [_vm._v("Action")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f029e14","hasScoped":false}!./src/views/components/SetSRTripConfiguration/SetSRTripConfiguration.component.html
// module id = 1270
// module chunks = 1